import "reflect-metadata";
import { injectable } from "inversify";
import {
  formatMobilePhone,
  isObviouslyFakePhone as isObviouslyFakePhoneInValidation,
  isValidMobilePhone,
  sanitizePhoneDigits,
} from "../../utils/validation";

export const PHONE_FORMAT_POLICY = Symbol("PHONE_FORMAT_POLICY");

export interface PhoneFormatPolicy {
  changeFormat(phone: string): string;

  isValid(phone?: string): boolean;
}

@injectable()
export class TypicalPhoneFormatPolicy implements PhoneFormatPolicy {
  public changeFormat(phone: string): string {
    return formatMobilePhone(phone);
  }

  public isCompletedNumber(phone: string): boolean {
    return sanitizePhoneDigits(phone).length === 11;
  }

  public isValid(phone?: string): boolean {
    if (phone == null || phone.trim() === "") {
      return true;
    }

    return isValidMobilePhone(phone);
  }

  public hasInvalidForm(phone: string): boolean {
    return /[^0-9-]/g.test(phone);
  }

  public removeDash(phone: string): string {
    return sanitizePhoneDigits(phone);
  }
}

export const typicalPhoneFormatPolicy = new TypicalPhoneFormatPolicy();

export const isObviouslyFakePhone = (value: string): boolean => {
  return isObviouslyFakePhoneInValidation(value);
};
